/* Tippy Type BuyBox — vanilla port of the React BuyBox.
   Brand tabs → model select → color swatches → qty → AJAX add-to-cart (Dawn drawer). */
class TippyBuyBox extends HTMLElement {
  constructor() {
    super();
    try {
      this.data = JSON.parse(this.querySelector('[data-buybox-data]').textContent).products || [];
    } catch (e) {
      this.data = [];
    }
    this.state = { brand: 0, variant: 0, model: '', qty: 1, media: 0 };
    this.$ = (s) => this.querySelector(s);
  }

  connectedCallback() {
    if (!this.data.length) {
      this.hidden = true;
      return;
    }
    this.bindStaticEvents();
    this.render();
  }

  get brand() { return this.data[this.state.brand]; }
  get variant() { return this.brand.variants[this.state.variant]; }

  bindStaticEvents() {
    this.$('[data-qty-dec]').addEventListener('click', () => { this.state.qty = Math.max(1, this.state.qty - 1); this.$('[data-qty]').textContent = this.state.qty; });
    this.$('[data-qty-inc]').addEventListener('click', () => { this.state.qty += 1; this.$('[data-qty]').textContent = this.state.qty; });
    this.$('[data-models]').addEventListener('change', (e) => { this.state.model = e.target.value; this.updateAtc(); });
    this.$('[data-atc]').addEventListener('click', () => this.addToCart());
  }

  selectBrand(i) {
    this.state.brand = i;
    this.state.variant = 0;
    this.state.model = '';
    this.state.media = 0;
    this.render();
  }

  selectVariant(i) {
    this.state.variant = i;
    this.state.media = 0;
    this.renderMedia();
    this.renderColors();
    this.$('[data-price]').textContent = this.variant.price;
    this.applyOmbre();
    this.updateAtc();
  }

  render() {
    const b = this.brand;
    this.$('[data-title]').textContent = b.title;
    this.$('[data-title-link]').href = b.url;
    this.$('[data-gallery-link]').href = b.url;
    this.$('[data-desc]').textContent = ''; // live BuyBox shows no description
    this.$('[data-price]').textContent = this.variant.price;

    // rating widget id
    const rating = this.$('[data-rating]');
    if (rating) { rating.setAttribute('data-id', b.rating_id || ''); rating.setAttribute('data-product-title', b.title || ''); }

    this.renderBrands();
    this.renderModels();
    this.renderColors();
    this.renderMedia();
    this.applyOmbre();
    this.updateAtc();
  }

  renderBrands() {
    const wrap = this.$('[data-brands]');
    wrap.innerHTML = '';
    if (this.data.length < 2) return;
    this.data.forEach((p, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tippy-buybox__brand' + (i === this.state.brand ? ' is-active' : '');
      btn.textContent = p.display || p.title;
      btn.addEventListener('click', () => this.selectBrand(i));
      wrap.appendChild(btn);
    });
  }

  renderModels() {
    const wrap = this.$('[data-models-wrap]');
    const sel = this.$('[data-models]');
    const models = Array.isArray(this.brand.models) ? this.brand.models : [];
    if (!models.length) { wrap.hidden = true; sel.innerHTML = ''; return; }
    wrap.hidden = false;
    sel.innerHTML = '<option value="">Select a model</option>' + models.map((m) => `<option value="${m}">${m}</option>`).join('');
    sel.value = this.state.model;
  }

  renderColors() {
    const wrap = this.$('[data-colors-wrap]');
    const box = this.$('[data-colors]');
    box.innerHTML = '';
    const variants = this.brand.variants;
    if (variants.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    variants.forEach((v, i) => {
      const sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'tippy-buybox__swatch' + (i === this.state.variant ? ' is-active' : '');
      sw.title = v.title;
      sw.style.backgroundColor = v.color || '#ccc';
      sw.addEventListener('click', () => this.selectVariant(i));
      box.appendChild(sw);
    });
  }

  renderMedia() {
    const main = this.$('[data-main]');
    const thumbs = this.$('[data-thumbs]');
    const media = this.brand.media && this.brand.media.length ? this.brand.media : (this.variant.image ? [{ type: 'image', url: this.variant.image }] : []);
    // prefer the selected variant image as first frame
    const list = this.variant.image ? [{ type: 'image', url: this.variant.image }, ...media] : media;
    main.innerHTML = this.mediaHtml(list[this.state.media] || list[0]);
    thumbs.innerHTML = '';
    list.forEach((m, i) => {
      const t = document.createElement('button');
      t.type = 'button';
      t.className = 'tippy-buybox__thumb' + (i === this.state.media ? ' is-active' : '');
      t.innerHTML = this.mediaHtml(m, true);
      t.addEventListener('click', (e) => { e.preventDefault(); this.state.media = i; this.renderMedia(); });
      thumbs.appendChild(t);
    });
  }

  mediaHtml(m, thumb) {
    if (!m) return '';
    if (m.type === 'video') {
      if (thumb && m.poster) return `<img src="${m.poster}" alt="" loading="lazy">`;
      return `<video src="${m.url}" muted loop playsinline autoplay poster="${m.poster || ''}"></video>`;
    }
    return `<img src="${m.url}" alt="" loading="lazy">`;
  }

  applyOmbre() {
    const color = this.variant.color || 'rgba(255,255,255,0)';
    this.querySelector('.tippy-buybox__inner').style.background = `radial-gradient(ellipse at top, #fff 0%, ${color} 90%)`;
  }

  updateAtc() {
    const btn = this.$('[data-atc]');
    const models = Array.isArray(this.brand.models) ? this.brand.models : [];
    const soldOut = !this.variant.available;
    const needsModel = models.length > 0 && !this.state.model;
    btn.disabled = soldOut || needsModel;
    btn.classList.toggle('is-disabled', btn.disabled);
    btn.textContent = soldOut ? 'Sold Out' : needsModel ? 'Select a Model' : 'Add to Cart';
  }

  async addToCart() {
    const btn = this.$('[data-atc]');
    if (btn.disabled) return;
    const item = { id: this.variant.id, quantity: this.state.qty };
    if (this.state.model) item.properties = { Model: this.state.model };

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
    btn.textContent = 'Adding…';
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.status) { this.updateAtc(); return; }
      if (drawer && drawer.renderContents) {
        drawer.renderContents(data);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: data });
      }
    } catch (e) {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    }
    this.updateAtc();
  }
}

customElements.define('tippy-buybox', TippyBuyBox);
